import React, { useState, useEffect } from 'react';
import styles from './ViewMoreModal.module.css';
import { getCasinoOpenBets } from '../../apiservices/CasionApi';
import BetViewMoreTable from './TableUi';

/**
 * View More modal – the downline's OPEN casino bets of this game (open-downline,
 * like the reference: no open bets = "No records found"; settled history is not
 * listed), numbered oldest first (No 1 = first placed). Fetched when opened. Table: No, UserName, Nation, Amount, User Rate, Place Date, IP, Browser Details.
 * Reference: lord-d99 lord-admin ViewMoreModal.
 */
const ViewMoreModal = ({
  show,
  onHide,
  title = 'View More',
  sectionKey = '',
  formatNation,
  formatRate,
}) => {
  const [internalData, setInternalData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !sectionKey) return;
    let cancelled = false;
    setLoading(true);
    getCasinoOpenBets(sectionKey, null, { allRounds: true })
      .then((res) => {
        if (cancelled) return;
        const list = res?.success && Array.isArray(res?.data) ? res.data : [];
        const time = (b) => new Date(b.created_at || b.placeDate || 0).getTime();
        setInternalData([...list].sort((a, b) => time(a) - time(b)));
      })
      .catch((err) => {
        if (!cancelled) {
          console.error('Error fetching ViewMoreModal data:', err);
          setInternalData([]);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [show, sectionKey]);

  if (!show) return null;

  return (
    <div className={`modal show d-block ${styles.modalOverlay}`} tabIndex="-1" role="dialog">
      <div className={`modal-dialog ${styles.modalDialogCustom}`} role="document">
        <div className={`modal-content ${styles.modalContentWrapper}`}>
          <header className={styles.modalHeader}>
            <h5 className={styles.modalTitle}>{title}</h5>
            <button
              type="button"
              className={styles.closeButton}
              onClick={onHide}
              aria-label="Close"
            >
              ×
            </button>
          </header>
          <div className={styles.modalBody}>
            {loading ? (
              <div className="text-center p-4">Loading...</div>
            ) : (
              <div className={styles.modalTableWrap}>
                <BetViewMoreTable data={internalData} formatNation={formatNation} formatRate={formatRate} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewMoreModal;
